import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import CryptoJS from "crypto-js";
//
import AppointmentRequestState from "./components/AppointmentRequestState";
import AppointmentRequestSucur from "./components/AppointmentRequestSucur";
import Availaptment from "./components/Availaptment";
import Review from "./components/Review";
import Stepper2 from "./components/Stepper";

const steps = ["Donde se ubica", "Seleccione una sucursal", "Agende su hora"];
function getStepContent(step, setActiveStep, handleNext) {
  switch (step) {
    case 0:
      return (
        <AppointmentRequestState
          activeStep={step}
          setActiveStep={setActiveStep}
          handleNext={handleNext}
        />
      );
    case 1:
      return (
        <AppointmentRequestSucur
          activeStep={step}
          setActiveStep={setActiveStep}
          handleNext={handleNext}
        />
      );
    case 2:
      return (
        <Availaptment
          activeStep={step}
          setActiveStep={setActiveStep}
          handleNext={handleNext}
        />
      );
    default:
      throw new Error("Unknown step");
  }
}

export default function Checkout(props) {
  const [activeStep, setActiveStep] = React.useState(0);
  //
  //
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  return (
    <>
      <Grid
        size={{ sm: 12, md: 7, lg: 8 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "100%",
          width: "100%",
          backgroundColor: { xs: "transparent", sm: "background.default" },
          alignItems: "start",
          pt: { xs: 0, sm: 0 },
          px: { xs: 2, sm: 2 },
          gap: { xs: 4, md: 8 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: { sm: "space-between", md: "flex-end" },
            alignItems: "center",
            width: "100%",
            maxWidth: { sm: "100%" },
          }}
        >
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-end",
              flexGrow: 1,
            }}
          >
            <Stepper
              id="desktop-stepper"
              activeStep={activeStep}
              sx={{ width: "100%", height: 40 }}
            >
              <Stepper2 activeStep={activeStep} />
            </Stepper>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            width: "100%",
            maxWidth: { sm: "100%" },
            gap: { xs: 5, md: "none" },
          }}
        >
          <Stepper
            id="mobile-stepper"
            activeStep={activeStep}
            alternativeLabel
            sx={{ display: { sm: "flex", md: "none" } }}
          >
            <Stepper2 activeStep={activeStep} />
          </Stepper>

          {activeStep === steps.length ? (
            <>
              <Stack spacing={2}>
                <Typography variant="h1">📅</Typography>
                <Typography variant="h5">Su cita fue agendada!</Typography>
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  "El correo de Confirmación de Cita ha sido enviado. Ingrese a
                  su correo y compruebe su cita agendada".
                </Typography>
                <Review />
              </Stack>
            </>
          ) : (
            <React.Fragment>
              {getStepContent(activeStep, setActiveStep, setActiveStep)}
              <Box
                sx={[
                  {
                    display: "flex",
                    flexDirection: { xs: "column-reverse", sm: "row" },
                    alignItems: "end",
                    flexGrow: 1,
                    gap: 1,
                    pb: { xs: 12, sm: 0 },
                    mt: { xs: 2, sm: 0 },
                    mb: "60px",
                  },
                  activeStep !== 0
                    ? { justifyContent: "space-between" }
                    : { justifyContent: "flex-end" },
                ]}
              >
                {activeStep !== 0 && (
                  <Button
                    startIcon={<ChevronLeftRoundedIcon />}
                    onClick={handleBack}
                    variant="outlined"
                    sx={{ display: { xs: "none", sm: "flex" } }}
                  >
                    Atrás
                  </Button>
                )}
                {activeStep !== 0 && (
                  <Button
                    startIcon={<ChevronLeftRoundedIcon />}
                    onClick={handleBack}
                    variant="outlined"
                    fullWidth
                    sx={{ display: { xs: "flex", sm: "none" } }}
                  >
                    Atrás
                  </Button>
                )}
                {/* <Button
                    variant="contained"
                    endIcon={<ChevronRightRoundedIcon />}
                    onClick={handleNext}
                    sx={{ width: { xs: "100%", sm: "fit-content" } }}
                  >
                    {activeStep === steps.length - 1 ? "Place order" : "Next"}
                  </Button> */}
              </Box>
            </React.Fragment>
          )}
        </Box>
      </Grid>
    </>
  );
}
